import { VariablesGlobales } from './../../providers/variables-globales';
import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';

/**
 * Generated class for the SplashscreenPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-splashscreen',
  templateUrl: 'splashscreen.html',
})
export class SplashscreenPage {

  constructor(public navCtrl: NavController, public navParams: NavParams,public viewCtrl: ViewController) {
  }
  ionViewDidEnter() {

    setTimeout(() => {
      this.viewCtrl.dismiss();
    }, 4000);

  }
  ionViewDidLoad() {
    if (navigator && navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position)=>{
        console.log(position.coords.latitude)
        VariablesGlobales.latitude = position.coords.latitude;
        VariablesGlobales.longitude = position.coords.longitude;
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/splashscreen/splashscreen.ts